import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=71cb06d0&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=71cb06d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb06d0",
  null
  
)

export default component.exports